<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="voters-information">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center mb-5">
      <img src="assets/square-icon.svg" alt="">
      <div>
        <p class="no-margin light-blue bold">Accueil des électeurs</p>
        <p class="no-margin dark-gray">Ces informations seront affichées sur la page d'accueil du site de vote.</p>
      </div>
    </div>
  </div>

  <div *ngIf="!votersConfirmed" id="poll-title" class="p-20">
    <div>
      <div class="flex flex-column gap-10 align-items-center content-center p-20 radius-10 pointer"
        (click)="fileInput.click()" appDragDrop (onFileDropped)="onFileDropped($event)"
        style="border: dotted 1px #1990FF;">
        <img src="assets/upload-icon.svg" width="20px">
        <p *ngIf="voters.length == 0" class="light-blue no-margin">Cliquez pour importer un fichier excel</p>
        <p *ngIf="voters.length != 0" class="light-blue no-margin">Cliquez pour changer de liste électorale</p>
        <input [disabled]="readonly" style="display: none" type="file" accept=".xlsx, .xls"
          (change)="onFileChanged($event); fileInput.value=''" #fileInput>
      </div>
    </div>
  </div>
</div>

<div class="w-full bg-white border-box radius-10 flex content-between align-items-center radius-10 mt-10 p-20"
  id="validate-voters" *ngIf="voters.length != 0 && !votersConfirmed">
  <div>
    <p class="bold dark-blue no-margin">Validation de la liste électorale</p>
    <p class="grey no-margin mt-10">Une fois validée, la liste era verrouillée et ne pourra plus être modifiée.</p>
  </div>
  <button *ngIf="isListReady" class="validate-button" (click)="displayValidateListPopup()">
    Valider la liste électorale
  </button>
  <div *ngIf="!isListReady">
    <p *ngIf="phoneErrorMessage.length > 0" class="no-margin dark-red">{{phoneErrorMessage}}</p>
    <p *ngIf="codeErrorMessage.length > 0" class="no-margin dark-red">{{codeErrorMessage}}</p>
  </div>

</div>

<div
  class="w-full bg-fourth-green border-green border-box radius-10 flex content-between align-items-center radius-10 mt-10 p-20"
  id="validate-voters-incomplete" *ngIf="votersConfirmed">
  <div>
    <p class="bold dark-blue no-margin">Liste électorale validée</p>
    <p class="grey no-margin mt-10">La liste est verrouillée et ne peut plus être modifiée.</p>
  </div>
</div>

<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;" id="voters-list">
  <div class="mt-20 p-20">
    <div class="flex content-between align-items-center mb-10">
      <div class="flex gap-10 align-items-center" [style.visibility]="getColleges.length > 0 ? 'visible' : 'hidden'">
        <p class="bold dark-blue no-margin">Filtrer par :</p>
        <div class="w-fit radius-5 pointer" style="padding: 5px 15px;" (click)="getCollegeVoters('Tous')"
          [style.backgroundColor]="activeCollegeFilter === 'Tous' ? '#1990FF' : '#F2F6FF'">
          <p class="no-margin" [style.color]="activeCollegeFilter === 'Tous' ? '#FFFFFF' : '#1990FF'">Tous</p>
        </div>
        <div *ngFor="let college of getColleges"
          [style.backgroundColor]="activeCollegeFilter === college ? '#1990FF' : '#F2F6FF'"
          class="w-fit radius-5 pointer" style="padding: 5px 15px;" (click)="getCollegeVoters(college)">
          <p class="no-margin" [style.color]="activeCollegeFilter === college ? '#FFFFFF' : '#1990FF'">{{college}} <span
              class="bg-white dark-gray radius-5" style="padding: 0px 5px;">{{getCollegeCount(college)}}</span></p>
        </div>
      </div>

      <div style="position: relative; display: inline-block;">
        <input name="search" type="text" class="pap-input dark-blue" #searchInput (input)="onSearch(searchInput.value)"
          placeholder="Rechercher..." style="width: 100%; box-sizing: border-box; padding-right: 30px;">
        <img src="assets/magnifier-icon.svg" alt="search" width="15px"
          style="position: absolute; right: 10px; transform: translateY(70%); pointer-events: none;">
      </div>

    </div>
    <div class="mb-10 flex content-between align-items-center">
      <div>
        <p class="bold light-blue">Électeurs inscrits : <span class="dark-blue">{{voters.length}}</span></p>
      </div>
      <div *ngIf="!votersConfirmed" class="flex gap-10">
        <v8te-active-button [buttonText]="'Ajouter'" [icon]="'assets/pen-icon.svg'" [iconAlt]="'add icon'"
          [primaryColor]="'#DEFEE6'" [secondaryColor]="'#FFECEC'" [textPrimaryColor]="'#32A24C'"
          [textSecondaryColor]="'#EF4444'" [border]="'none'" (click)="addVoter()" [height]="'40px'" [minWidth]="'120px'"
          [width]="'120px'"></v8te-active-button>
        <v8te-active-button [buttonText]="'Supprimer'" [icon]="'assets/trash-red-icon.svg'" [iconAlt]="'trash icon'"
          [primaryColor]="'#FEECEC'" [secondaryColor]="'#FFECEC'" [textPrimaryColor]="'#EF4444'"
          [textSecondaryColor]="'#EF4444'" [border]="'none'"
          (click)="selectedVoters.length > 0 && displayDeleteVoterPopup()" [height]="'40px'" [minWidth]="'120px'"
          [width]="'120px'" [active]="selectedVoters.length > 0"></v8te-active-button>
      </div>
    </div>

    <app-import-table [(selectedVoters)]="selectedVoters" [filteredVoters]="filteredVoters"
      (voterEdited)="onVoterEdited()" [editionMode]="!votersConfirmed"></app-import-table>
  </div>
  <voters-delete-popup *ngIf="deleteVoterPopup" (isClosed)="deleteSelected($event)"
    [voters]="selectedVoters"></voters-delete-popup>
  <voters-add-popup *ngIf="addVoterPopup" (isClosed)="closeAddVoterPopup()"
    (voterAdded)="addSelected($event)"></voters-add-popup>
  <voters-validate-popup *ngIf="validateListPopup" (isClosed)="validateList($event)"></voters-validate-popup>
</div>